import { API } from "@/main";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchAllClientRoles({ commit }, includes) {
    return new Promise((resolve, reject) => {
      API.clientRoles.getAll(
        includes,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchAllClientRolesParams({ commit }, queryParams) {
    return new Promise((resolve, reject) => {
      API.clientRoles.getAllParams(
        queryParams,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchAllClientRolesParamsId({ commit }, id, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.clientRoles.getAllParamsId(
        id,
        queryParams,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchClientRolesByUuid({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.clientRoles.getByUuid(
        data.uuid,
        data.includes,
        result => {
          resolve(result.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addClientRoles({ commit }, clientRoleData) {
    return new Promise((resolve, reject) => {
      API.clientRoles.create(
        clientRoleData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editClientRoleUuid({ commit }, { uuid, updatedData }) {
    return new Promise((resolve, reject) => {
      API.clientRoles.edit(
        uuid,
        updatedData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteClientRoleByUuid({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.clientRoles.delete(
        uuid,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/clientRoles.js